import { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  Page404,
  ModalChat,
  ModalLegal,
  ModalContact,
  DrawerShared,
  Snackbar,
  Modal,
} from "components";
import { ResetPassword, TermsAndConditions } from "pages/public";
import { useGlobalContext } from "context/GlobalContext";
import AOS from "aos";
import App from "./app";
import Dashboard from "./dashboard";

import { PrivateRoute, PublicRoute } from "./components";
import "aos/dist/aos.css";

const Index = () => {
  const gContext = useGlobalContext();

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      <Router>
        <Switch>
          <PublicRoute
            exact
            path="/identificate"
            authed={gContext.isAuthed}
            component={App}
          />
          <PublicRoute
            path="/legal"
            authed={false}
            component={TermsAndConditions}
          />
          <PublicRoute
            path="/recuperar-acceso"
            authed={gContext.isAuthed}
            component={ResetPassword}
          />
          <PrivateRoute
            path="/"
            authed={gContext.isAuthed}
            component={Dashboard}
          />

          {/* <Route path="/legal" component={TermsAndConditions} /> */}
          <Route path="*" component={Page404} />
        </Switch>
      </Router>
      <Modal />
      <ModalChat />
      <ModalContact />
      <ModalLegal />
      <DrawerShared />
      <Snackbar />
    </div>
  );
};

export default Index;
